import { IComponentOptions } from "angular";

export const FeatureNotAvailableComponent: IComponentOptions = {
  templateUrl: require("./feature-not-available.jade"),
};
